import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';

export const courseExporter = async (courses, fetchRelatedRecords) => {
  const categories = await fetchRelatedRecords(courses, 'categories', 'categories');
  const rows = courses.map((course) => ({
    ...course,
    categories: (course.categories || [])
      .map((id) => categories[id]?.name || '')
      .filter(Boolean)
      .join('; '),
  }));

  jsonExport(rows, (error, csv) => {
    if (error) throw error;
    downloadCSV(csv, 'courses');
  });
};
